import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';

// Importaciones de servicios.
import { MeService } from '../services/me.service';

// Importaciones de interfaces.
import { IEmployee } from '../interfaces/employee.interface';

/**
 * Guard que controla el acceso a rutas según el rol del usuario.
 *
 * Este guard verifica si el usuario tiene el rol de administrador
 * antes de permitir el acceso a la ruta. Si el usuario tiene el rol
 * adecuado, permite la activación de la ruta, de lo contrario, la bloquea.
 *
 * @returns Retorna `true` si el usuario tiene el rol de 'admin_role',
 * o `false` en caso contrario o si ocurre un error.
 */
export const roleGuard: CanActivateFn = async (): Promise<boolean> => {
  const meService = inject(MeService);

  try {
    const meResponse: IEmployee = await meService.get();
    return meResponse.role.name === 'admin_role';
  } catch (errors: any) {
    return false;
  }
};
